<template>
  <div>
    <hi-cell title="结果报批单号：" :value="headInfo.resultApplyCode"></hi-cell>
    <hi-cell title="供货品类：" :value="headInfo.catgName"></hi-cell>
    <hi-cell title="企业属性：" :value="headInfo.enterpriseNature" :options="enterpriseNatureOptions"></hi-cell>
    <hi-cell title="申请采购组织：" :value="headInfo.purorgName"></hi-cell>
    <hi-cell title="供应商：" :value="headInfo.suppName"></hi-cell>
    <hi-cell title="采购：" :value="headInfo.purUserName"></hi-cell>
    <hi-cell title="研发：" :value="headInfo.devUserName"></hi-cell>
    <hi-cell title="质量：" :value="headInfo.quaUserName"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    enterpriseNatureOptions() {
      return this.$store.getters.dicts.enterprise_type
    }
  }
}
</script>
